WiseMetering.Views.ShowZaptecConfiguration = WiseMetering.Views.Modal.Show.extend({
    className: 'mbx-info text-left',
    template: 'templates/integration_configurations/zaptec/show',
    title: () => i18next.t('modal.title.integration_configurations.show'),

    edit: function() {
        new WiseMetering.Views.EditZaptecConfiguration({ model: this.model });
    }
});
